import React from 'react';
import { Box } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import useStyles from './styles';

const Loading = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      {[1, 2].map(item => (
        <Box key={item} className="skeleton-file-item-container">
          <Skeleton className="skeleton-file-item-avatar" variant="circle" />
          <Box className="skeleton-file-item-text">
            <Skeleton variant="text" width="50%" />
            <Skeleton variant="text" width="30%" />
          </Box>
          <Skeleton className="skeleton-file-item-icon" variant="circle" />
        </Box>
      ))}
    </Box>
  );
};

export default Loading;
